var map = {
	"./ca.json": [
		"c1c8",
		"lang-ca-json"
	],
	"./en.json": [
		"f8e2"
	],
	"./es.json": [
		"e1a6",
		"lang-es-json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "50b8";
module.exports = webpackAsyncContext;